import React from 'react';

export const Link = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1031 18H6.70312C5.18146 18 3.88456 17.4636 2.81243 16.3907C1.73956 15.3186 1.20312 14.0217 1.20312 12.5C1.20312 10.9783 1.73956 9.68107 2.81243 8.6082C3.88456 7.53607 5.18146 7 6.70312 7H11.1031V9.2H6.70312C5.78646 9.2 5.00729 9.52083 4.36563 10.1625C3.72396 10.8042 3.40313 11.5833 3.40313 12.5C3.40313 13.4167 3.72396 14.1958 4.36563 14.8375C5.00729 15.4792 5.78646 15.8 6.70312 15.8H11.1031V18ZM7.80313 13.6V11.4H16.6031V13.6H7.80313ZM13.3031 18V15.8H17.7031C18.6198 15.8 19.399 15.4792 20.0406 14.8375C20.6823 14.1958 21.0031 13.4167 21.0031 12.5C21.0031 11.5833 20.6823 10.8042 20.0406 10.1625C19.399 9.52083 18.6198 9.2 17.7031 9.2H13.3031V7H17.7031C19.2248 7 20.5221 7.53607 21.5949 8.6082C22.6671 9.68107 23.2031 10.9783 23.2031 12.5C23.2031 14.0217 22.6671 15.3186 21.5949 16.3907C20.5221 17.4636 19.2248 18 17.7031 18H13.3031Z"
      fill={color || '#6E6B8C'}
    />
  </svg>
);
